import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { SearchCriteriaModel } from '../../models/platform/searchCriteriaModel';
import { SearchesModel } from '../../models/platform/searchesModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class SearchApi {

    async createSearch(search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/searches/`, search,
                {
                    headers: authHeader(),
                });

            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async deleteSearch(search_id: string) {
        try {
            const response = await axios.delete(`${API_URL}/api/searches/${search_id}`, {
                headers: authHeader(),
            });

            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getOptions() {
        try {
            const response = await axios.get(`${API_URL}/api/searches/options`,
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }

    async getSearchById(search_id: string) {
        try {
            const response = await axios.get(`${API_URL}/api/searches/${search_id}`,
                {
                    headers: authHeader(),
                });

            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }
    
    async getSearchesByAccountId() {
        try {
            const response = await axios.get(`${API_URL}/api/searches/me`,
                {
                    headers: authHeader(),
                });

            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async updateSearch(search_id: string, search: SearchesModel) {
        try {
            const response = await axios.put(`${API_URL}/api/searches/${search_id}`, search,
                {
                    headers: authHeader(),
                });

            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async updateSearchName(search_id: string, search_name: string) {
        try {
            const response = await axios.patch(`${API_URL}/api/searches/${search_id}/name`, { search_name },
                {
                    headers: authHeader(),
                });

            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }
}

const searchApi = new SearchApi();
export default searchApi;